/** Synced from package.json version via npm run version:sync */
export const APP_VERSION = '0.43.0';
